var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-img01"},[_c('div',{staticClass:"back-area",on:{"click":function($event){return _vm.$router.go(-1)}}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-container"},[_c('img',{staticClass:"display-img",attrs:{"src":require("@/assets/imgs/1.jpg"),"alt":"图片展示"}})])
}]

export { render, staticRenderFns }